import PropTypes from 'prop-types';
import cn from 'classnames';

function LdsHorizontalRule({
  color = undefined,
  width = undefined,
  className = undefined,
  ...rest
}) {
  return (
    <hr
      className={cn(
        'lds-hr',
        className
      )}
      style={{
        borderTopColor: color || '#212121',
        width: width ? `${width}%` : '100%',
      }}
      {...rest}
    />
  );
}

export default LdsHorizontalRule;

LdsHorizontalRule.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
};
